import Http from './../../services/HTTP';

const UPLOAD_LAB_ORDER_RESULT = 'UPLOAD_LAB_ORDER_RESULT';

function uploadLabOrderResultWaiting() {
    return {
      type: UPLOAD_LAB_ORDER_RESULT,
      upload_lab_order_result_waiting: true,
      upload_lab_order_result_response: {},
      upload_lab_order_result_error: {},
    };
  }

  function uploadLabOrderResultSuccess(response) {
    return {
      type: UPLOAD_LAB_ORDER_RESULT,
      upload_lab_order_result_waiting: false,
      upload_lab_order_result_response: response,
      upload_lab_order_result_error: {},
    };
  }
  
  function uploadLabOrderResultError(error) {
    return {
      type: UPLOAD_LAB_ORDER_RESULT,
      upload_lab_order_result_waiting: false,
      upload_lab_order_result_response: {},
      upload_lab_order_result_error: error,
    };
  }

  function uploadLabOrderResultEmpty() {
    return {
      type: UPLOAD_LAB_ORDER_RESULT,
      upload_lab_order_result_waiting: false,
      upload_lab_order_result_response: {},
      upload_lab_order_result_error: {},
    };
  }
  
  function uploadLabOrderResult(data) {
    return (dispatch) => {
      dispatch(uploadLabOrderResultWaiting());
      const post = Http.POST_FORM("v1/medical_delivery/files",data,{},);
      post
        .then((response) => {
          if (response !== undefined) dispatch(uploadLabOrderResultSuccess(response));
        })
        .catch((error) => {
          dispatch(uploadLabOrderResultError(error));
        });
    };
  }

  export {
      UPLOAD_LAB_ORDER_RESULT,
      uploadLabOrderResult,
      uploadLabOrderResultEmpty,
  }